import posthog from 'posthog-js'

/**
 * Typed wrappers for all PostHog custom events.
 * Import Analytics from here instead of calling posthog.capture() directly.
 */
export const Analytics = {
  // ─── Campaign / Conversion Funnel ────────────────────────────────────────

  /** Landing page loaded — captures UTM params and referrer. */
  landingPageVisit: () => {
    const params = new URLSearchParams(window.location.search)
    posthog.capture('landing_page_visit', {
      utm_source: params.get('utm_source') || undefined,
      utm_medium: params.get('utm_medium') || undefined,
      utm_campaign: params.get('utm_campaign') || undefined,
      referrer: document.referrer || undefined,
    })
  },

  /** Waitlist / email capture form successfully submitted. */
  emailCaptured: (source: string) =>
    posthog.capture('email_captured', { source }),

  /** User clicks an upgrade CTA. */
  upgradeStarted: (fromTier: string, toTier: string, source: string) =>
    posthog.capture('upgrade_started', { from_tier: fromTier, to_tier: toTier, source }),

  // upgrade_completed — TODO: fire on Stripe payment success redirect when billing ships

  // ─── Product Actions ─────────────────────────────────────────────────────

  /** A new expense was created. */
  expenseCreated: (category: string, hasDocuments: boolean) =>
    posthog.capture('expense_created', { category, has_documents: hasDocuments }),

  /** An expense was deleted. */
  expenseDeleted: () =>
    posthog.capture('expense_deleted'),

  /** A document was uploaded to the library or attached to an expense. */
  documentUploaded: (documentType: string, fileType: string) =>
    posthog.capture('document_uploaded', { document_type: documentType, file_type: fileType }),

  /** An export was downloaded. */
  exportDownloaded: (exportType: 'csv' | 'zip') =>
    posthog.capture('export_downloaded', { export_type: exportType }),

  /** A reimbursement was recorded against an expense. */
  reimbursementRecorded: () =>
    posthog.capture('reimbursement_recorded'),

  /** A new HSA account was added. */
  accountCreated: () =>
    posthog.capture('account_created'),

  /** Bulk CSV import completed successfully. */
  bulkImportCompleted: (props: {
    countTotal: number
    countOverLimit: number
    totalValue: number
    autoCreatedFamilyMembers: number
    autoCreatedHsaAccounts: number
  }) =>
    posthog.capture('bulk_import_completed', {
      count_total: props.countTotal,
      count_over_limit: props.countOverLimit,
      total_value: props.totalValue,
      auto_created_family_members: props.autoCreatedFamilyMembers,
      auto_created_hsa_accounts: props.autoCreatedHsaAccounts,
    }),
}
